export enum SituacaoEnum {
  NaoConcluido = 1,
  EmAnalise = 2,
  ParaCorrecao =3,
  Corrigido=4,
  Homologado=5,
  Pontuado=6,
  Desclassificado=7
}
